<template>
  <v-col
    v-if="$store.state.auth.checkAccess({key: 'kyc', value: true})"
    :cols="12"
    style="margin-top: -50px;"
    :class="{'px-0': true}"
  >


    <material-card color="green">
      <template v-slot:header>
        <v-row class="px-3 mx-0">
          <h4 class="title font-weight-light mb-0" v-html="`KYC (${kycTitle})`"></h4>
          <v-spacer />

          <default-history
            class="d-inline-block"
            type="kyc"
            handler="default"
            icon="history"
            color="white"
            width="750"
            title="KYC History"
          />
        </v-row>

      </template>
      <v-row justify="space-around">

        <v-checkbox
          v-for="(value, key) in kyc.details"
          class="ma-0"
          :label="key"
          :key="activeAccount.account_id + key"
          @change="save(key, ['details', key])"
          v-model="kyc.details[key]"
          hide-details
          :readonly="!$store.state.auth.checkAccess({key: 'kyc_verification', value: true})"
        />

      </v-row>
      <v-row class="mx-2 mt-2">
        <v-switch
          class="ml-3 mt-5 py-0"
          label="Verified"
          hide-details
          @change="save('Verified', ['verified'])"
          v-model="kyc.verified"
          :readonly="!$store.state.auth.checkAccess({key: 'kyc_verification', value: true})"
        />

        <v-spacer />

        <v-switch
          class="ml-3 mt-5 py-0"
          label="Automatic Verified"
          hide-details
          @change="save('Automatic Verification', ['primary_verification'])"
          v-model="kyc.primary_verification"
          :readonly="!$store.state.auth.checkAccess({key: 'kyc_verification', value: true})"
        />

        <v-spacer />

        <v-item-group
          v-if="$store.state.auth.checkAccess({key: 'document_link', value: true})"
          class="v-btn-toggle v-btn-toggle--borderless mt-4"
        >
          <v-btn small dark color="info" :href="kycData.document" target="_blank">Documents</v-btn>

          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-width="200"
            offset-y
            bottom
          >
            <template v-slot:activator="{ on }">
              <v-btn small dark color="info" fab style="height: 28px;" v-on="on">
                <v-icon small>mdi-arrow-down</v-icon>
              </v-btn>
            </template>

            <v-card :height="!$store.state.auth.checkAccess({key: 'update_document_link', value: true}) ? 35 : ''">
              <v-row class="ml-4 mr-0">
                <v-text-field
                  v-model="kycData.document"
                  placeholder="Documents link"
                  hide-details
                  :readonly="!$store.state.auth.checkAccess({key: 'update_document_link', value: true})"
                  class="mt-0 pt-0 mb-0 pb-0"
                ></v-text-field>
                <v-btn v-if="$store.state.auth.checkAccess({key: 'update_document_link', value: true})" color="info" text @click="save('Save documents url', 'document', true); menu = false">Save</v-btn>
              </v-row>
            </v-card>
          </v-menu>
        </v-item-group>
        <v-btn-toggle style="display: none;"></v-btn-toggle>
      </v-row>

    </material-card>

  </v-col>
</template>

<script>
  import { get, reduce, set, toNumber } from 'lodash'
  import { mask } from 'vue-the-mask'
  import { API } from '@/utils/api'
  import { findParentComponentByTag } from '@/utils/helper'
  import { mapGetters } from 'vuex'

  export default {
    directives: {
      mask,
    },
    props: [],
    components: {
      DefaultHistory: () => import('@/components/helper/DefaultHistory'),
    },

    data: () => ({
      menu: null,
    }),

    computed: {
      ...mapGetters({ activeAccount: 'account/active', documents: 'account/documents', kyc: 'account/kyc', kycData: 'account/kycData' }),
      kycTitle () {
        if (reduce(this.kyc.details, (r, v) => r && v, true)) {
          return 'verified'
        } else {
          return 'not verified'
        }
      },
    },

    created () {
    },

    methods: {

      async save (field, path, isData = false) {

        if (!this.$store.state.auth.checkAccess({ key: 'kyc_verification', value: true }) ||
          !await this.$root.$confirm('Confirm', `Update ${field}: ${get(isData ? this.kycData : this.kyc, path) ? 'Yes' : 'No'}`)) {
          set((isData ? this.kycData : this.kyc), path, !get((isData ? this.kycData : this.kyc), path))

          return
        }

        let params = { login: this.activeAccount.account.login, account_id: this.activeAccount.account_id }

        set(params, path, get((isData ? this.kycData : this.kyc), path))

        this.loading = true
        API.call('/$v/account/kyc/update.json', params, this.activeAccount.account).then(resp => {
        }).finally(r => {
          this.loading = false
        })
      },
    }

  }
</script>
